import { makeStyles, mergeClasses, tokens, typographyStyles } from '@fluentui/react-components';
import type { SensitivityTooltipSlots, SensitivityTooltipState } from './SensitivityTooltip.types';
import type { SlotClassNames } from '@fluentui/react-components';

export const sensitivityTooltipClassNames: SlotClassNames<SensitivityTooltipSlots> = {
  root: 'fai-SensitivityTooltip',
  heading: 'fai-SensitivityTooltip__heading',
  message: 'fai-SensitivityTooltip__message',
  previewSurface: 'fai-SensitivityTooltip__previewSurface',
  trigger: 'fai-SensitivityTooltip__trigger',
};

/**
 * Styles for the root slot
 */
const useStyles = makeStyles({
  root: {},
  heading: {
    ...typographyStyles.caption1Stronger,
    color: tokens.colorNeutralForeground1,
  },
  message: {},
  previewSurface: {
    maxWidth: '293px',
  },
  trigger: {},
});

/**
 * Apply styling to the SensitivityTooltip slots based on the state
 */
export const useSensitivityTooltipStyles_unstable = (state: SensitivityTooltipState): SensitivityTooltipState => {
  const styles = useStyles();
  state.root.className = mergeClasses(sensitivityTooltipClassNames.root, styles.root, state.root.className);

  if (state.heading) {
    state.heading.className = mergeClasses(
      sensitivityTooltipClassNames.heading,
      styles.heading,
      state.heading.className,
    );
  }

  if (state.message) {
    state.message.className = mergeClasses(
      sensitivityTooltipClassNames.message,
      styles.message,
      state.message.className,
    );
  }

  if (state.previewSurface) {
    state.previewSurface.className = mergeClasses(
      sensitivityTooltipClassNames.previewSurface,
      styles.previewSurface,
      state.previewSurface.className,
    );
  }

  if (state.trigger) {
    state.trigger.className = mergeClasses(
      sensitivityTooltipClassNames.trigger,
      styles.trigger,
      state.trigger.className,
    );
  }

  return state;
};
